import { ReactNode, CSSProperties } from "react";

export interface IconBaseProps {
  viewBox?: string;
  size?: string | number;
  width?: string | number;
  height?: string | number;
  color?: string;
  noPointer?: boolean;
  title?: string;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
  "data-testid"?: string;
}

const DEFAULT_SIZE = 20;
const DEFAULT_COLOR = "var(--color-easil-gray-x-dark)";

const IconBase = ({
  viewBox = "0 0 20 20",
  size = DEFAULT_SIZE,
  width,
  height,
  color,
  noPointer,
  title,
  className,
  style,
  children,
  "data-testid": dataTestId
}: IconBaseProps) => (
  <svg
    className={className}
    style={{ ...style, color: color || DEFAULT_COLOR }}
    data-no-pointer={noPointer}
    data-testid={dataTestId}
    width={width || size}
    height={height || size}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    {title ? <title>{title}</title> : null}
    {children}
  </svg>
);

export default IconBase;
